import { Loader } from "@app/components/core/Loader/Loader"
import { Link } from "@app/components/order/LinkList/LinkList"
import { MyParadiseNewsModal } from "@app/modals/MyParadise/MyParadiseNewsModal/MyParadiseNewsModal"
import { RenderHTML } from "@app/utils/htmlUtils"
import { getDateString } from "@app/utils/localeUtils"
import { emptyArray } from "@app/utils/objectUtils"
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { classNamez, useModal } from "@tecreation/funnel-components"
import { useEffect, useRef, useState } from "react"

import { useGetEmployeeNews } from "@app/store/service/connectorService"
import "./MyParadiseEmployeeNews.css"

function NewsEntry({ news }) {
	const srcUrl = news.medias?.find(e => e.thumbnail === true)?.url
	const { showModal } = useModal()
	return (
		<div
			className="relative h-100 of-hidden news"
			style={{ minWidth: "100%", maxHeight: "280px" }}
			onClick={() => {
				showModal(MyParadiseNewsModal, { news })
			}}
		>
			<div className="myParadiseBluphoria" style={{ backgroundImage: 'url("' + srcUrl || "" + '")', opacity: ".2", height: "100%" }}>
				<img src={srcUrl} style={{ opacity: 0, width: "100%" }} />
			</div>
			<div className="absolute top-0 left-0 px-8 py-8">
				<div className="mb-3 f4">{getDateString(new Date(news.creationDateTime))}</div>
				<div className="f3 mb-3">
					<RenderHTML html={news.subject} />
				</div>
				<div className="">
					<Link
						noItalic
						href="#"
						onClick={e => {
							e.preventDefault()
						}}
						className="f4"
					>
						Weiterlesen
					</Link>
				</div>
			</div>
		</div>
	)
}

export default function MyParadiseEmployeeNews() {
	const containerRef = useRef(undefined)
	const [newsIndex, setNewsIndex] = useState(0)

	const { data: news, isFetching } = useGetEmployeeNews()

	useEffect(() => {
		if (containerRef.current) {
			containerRef.current.scrollTo({
				left: containerRef.current.clientWidth * newsIndex,
				behavior: "smooth",
			})
		}
	}, [newsIndex])

	if (isFetching) {
		return (
			<div className="relative h-100 flex flex-center" style={{ minHeight: "300px" }}>
				<Loader show={isFetching} />
			</div>
		)
	}
	return (
		<div className="relative h-100">
			<div
				className="absolute left-0 px-3 py-2 color-bg-primary color-fg-white z-9"
				style={{ top: "50%", transform: "translateY(-50%)" }}
				onClick={e => {
					e.stopPropagation()
					if (newsIndex !== 0) {
						setNewsIndex(newsIndex - 1)
					}
				}}
			>
				<FontAwesomeIcon icon={faChevronLeft} />
			</div>
			<div
				className="absolute right-0 px-3 py-2 color-bg-primary color-fg-white z-9"
				style={{ top: "50%", transform: "translateY(-50%)" }}
				onClick={e => {
					e.stopPropagation()
					if (newsIndex !== news.length - 1) {
						setNewsIndex(newsIndex + 1)
					}
				}}
			>
				<FontAwesomeIcon icon={faChevronRight} />
			</div>
			<div className="flex of-x-hidden h-100" ref={containerRef}>
				{news.map((n, i) => {
					return <NewsEntry news={n} key={i} />
				})}
			</div>
			<div className="absolute bottom-0 w-100 flex flex-center pb-3">
				{emptyArray(news.length).map((__, i) => {
					return (
						<div
							className={
								"border color-border-primary mr-1" +
								classNamez({
									"color-bg-primary": i === newsIndex,
								})
							}
							key={i}
							style={{ height: "5px", width: "5px" }}
						/>
					)
				})}
			</div>
		</div>
	)
}
